import {
  Box,
  Dialog,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import React, { Component } from "react";
import { connect } from "react-redux";
import "../../CSS/app.min.css";
import "../../CSS/bootstrap.min.css";
import "../../CSS/custom.min.css";
import "../../CSS/mermaid.min.css";
import "../../CSS/slickDashboard.css";

import { styled, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { Link, Link as RouterLink } from "react-router-dom";
import checklist from "../../Images/CheckListLogo.png";
import ShoppingTrolly from "../../Images/ShoppingTrolly.png";
import workers from "../../Images/builders.png";
import crnLogo from "../../Images/crnLogo.png";
import vehicle from "../../Images/delivery-truck.png";
import grnLogo1 from "../../Images/grnLogo1.png";
import sales from "../../Images/sales.png";
import store from "../../Images/store.png";
import {
  showLoador,
  showNotification,
} from "../../Pages/Landing/Landing.slice";
import {
  getPendingBills,
  getSalesDataByDate,
  getSalesDataByMonth,
  getTopPerformingEntities,
} from "../../Slice/StackHolder.slice";
import { getSalesTeamInfoByDatesWithAttendance } from "../../Slice/adminDashboard.slice";
import { getStockHolderSummary } from "../../Slice/analyticalStockHolder.slice";
import { getBeatFromSalesTeamId } from "../../Slice/beat.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import RTTable from "../../components/Comman/RT/RTTable";
import MonthCalender from "../../components/MonthCalender";
import { cyanBlue, redColor, titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import BeatPopUp from "../DashbourdChanges/BeatPopUp";
import { downloadF } from "../PDF/PDFDownload";

const StickyTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#fff",
    // color: theme.palette.common.white,
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 2,
  },
  body: {
    backgroundColor: "#fff",
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
  },
}))(TableCell);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="TabPanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

class AnalyticalStockHolderDashboard extends Component {
  state = {
    newDate: "",
    date: "",
    saleMonth: dayjs(),
    topProductSaleMonth: dayjs(),
    outletPendingDate: dayjs(),
    datePending: dayjs(),
    searchValueForProduct: "",
    topPerformingProductData: [],
    searchValueForOutlets: "",
    topPerformingOutletData: [],
    searchValueForPendingBill: "",
    pendingBillData: [],
    searchValueForPending: "",
    searchValueForSalesTeamList: "",
    totalOutletCount: 0,
    zero: 0,
    productiveCall: 0,
    unvisited: 0,
    totalAmount: 0,
    salesAmt: 0,
    remoteOrder: 0,
    dateForSalesTeamList: dayjs(),
    pendingBillDataBottomColumn: [],
    searchValueForPendingBottomColumn: "",
    value: "0",
    count: 0, //for toggle
    refreshCardDateFlag: false,
    onChangeFlag: false,
    searchValueForProductPrimary: "",
    searchValueForStockHolders: "",
    searchValueForPendingPrimary: "",
    formErrors: {},
    beatPopupFlag: false,
    pendingSaleMonth: localStorage.getItem("pendingSaleMonth")
      ? dayjs(localStorage.getItem("pendingSaleMonth"))
      : dayjs(),
    datePending: localStorage.getItem("datePending")
      ? dayjs(localStorage.getItem("datePending"))
      : dayjs(),
    saleMonth: localStorage.getItem("saleMonth")
      ? dayjs(localStorage.getItem("saleMonth"))
      : dayjs(),
  };

  async componentDidMount() {
    const {
      showLoador,
      showNotification,
      getStockHolderSummary,
      getPendingBills,
      getTopPerformingEntities,
      getSalesDataByMonth,
    } = this.props;
    if (navigator.onLine) {
      const stockHolderSummaryData = localStorage.getItem("stockHolderSummary");
      const stockHolderSummaryLocalStorage = JSON.parse(stockHolderSummaryData);

      const getPendingBillsData = localStorage.getItem("getPendingBills");
      const getPendingBillsLocalStorage = JSON.parse(getPendingBillsData);

      const getTopPerformingEntity = localStorage.getItem("getTopPerforming");
      const getTopPerformingEntitiesLocalStorage = JSON.parse(
        getTopPerformingEntity
      );

      const { pendingSaleMonth } = this.state;


      localStorage.setItem("isStockHolderDashboard", 1)


      if (!stockHolderSummaryLocalStorage) {
        showLoador({ loador: true });
        await getStockHolderSummary({
          monthYear: dayjs().format("MM-YYYY"),
        }).then(({ success, response }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem(
              "stockHolderSummary",
              JSON.stringify(response)
            );
          }
        });
      }

      if (!getPendingBillsLocalStorage) {
        showLoador({ loador: true });
        await getPendingBills({
          monthYear: dayjs().format("MM-YYYY"),
        }).then(({ success, response }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("getPendingBills", JSON.stringify(response));
          }
        });
      }

      if (!getTopPerformingEntitiesLocalStorage) {
        showLoador({ loador: true });
        await getTopPerformingEntities({
          monthYear: dayjs().format("MM-YYYY"),
        }).then(({ success, response }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("getTopPerforming", JSON.stringify(response));
          }
        });
      }

      showLoador({ loador: true });
      await getSalesDataByMonth({
        monthYear: dayjs(pendingSaleMonth).format("MM-YYYY"),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (success && response) {
          this.setState({ onChangeFlag: true });
        } else {
          localStorage.setItem("stockHolderSummary", JSON.stringify(response));
          this.setState({ onChangeFlag: false });
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    }
  }

  onDateChangeMtd = async (date, name) => {
    const {
      getSalesDataByMonth,
      getSalesDataByDate,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      this.setState(
        {
          [name]: date,
          onChangeFlag: true,
        },
        () => {
          if (name === "pendingSaleMonth") {
            localStorage.setItem("pendingSaleMonth", date.toString());
          }
        }
      );
      if (name === "pendingSaleMonth") {
        showLoador({ loador: true });
        await getSalesDataByMonth({
          monthYear: dayjs(date).format("MM-YYYY"),
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (success && response) {
          } else {
            localStorage.setItem(
              "stockHolderSummary",
              JSON.stringify(response)
            );
            this.setState({
              onChangeFlag: false,
            });
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      } else if (name === "topProductSaleMonth") {
        showLoador({ loador: true });
        await getSalesDataByDate({
          date: dayjs(date).format("DD-MM-YYYY"),
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (success && response) {
            this.setState({
              refreshCardDateFlag: true,
            });
          } else {
            this.setState({
              onChangeFlag: false,
              refreshCardDateFlag: false,
            });
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onDateChangePending = async (date, name) => {
    const {
      showLoador,
      showNotification,
      getPendingBills,
      getPendingBillsLocalStorage,
    } = this.props;
    if (navigator.onLine) {
      this.setState(
        {
          [name]: date,
        },
        () => {
          localStorage.setItem("datePending", date.toString());
        }
      );
      showLoador({ loador: true });
      if (!getPendingBillsLocalStorage) {
        getPendingBills({
          monthYear: dayjs(date).format("MM-YYYY"),
        }).then(({ success, response }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("getPendingBills", JSON.stringify(response));
            this.setState({});
          }
        });
      } else {
        showNotification({ msg: noInternetMsg, severity: "error" });
      }
    }
  };

  onDateChangePerformance = async (date, name) => {
    const {
      showLoador,
      showNotification,
      getTopPerformingEntities,
      getTopPerformingEntitiesLocalStorage,
    } = this.props;
    if (navigator.onLine) {
      this.setState(
        {
          [name]: date,
        },
        () => {
          localStorage.setItem("saleMonth", date.toString());
        }
      );
      showLoador({ loador: true });
      showLoador({ loador: true });
      if (!getTopPerformingEntitiesLocalStorage) {
        getTopPerformingEntities({
          monthYear: dayjs(date).format("MM-YYYY"),
        }).then(({ success, response }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            localStorage.setItem("getTopPerforming", JSON.stringify(response));
            this.setState({});
          }
        });
      } else {
        showNotification({ msg: noInternetMsg, severity: "error" });
      }
    }
  };

  onSearchForPedning = (searchValueForPending) => {
    this.setState({
      searchValueForPending: searchValueForPending,
    });
  };

  onSearchForPerformingProducts = (searchValueForProduct) => {
    this.setState({
      searchValueForProduct: searchValueForProduct,
    });
  };

  onSearchForPerformingProductPrimary = (searchValueForProductPrimary) => {
    this.setState({
      searchValueForProductPrimary: searchValueForProductPrimary,
    });
  };

  onSearchForPerformingStockHolders = (searchValueForStockHolders) => {
    this.setState({
      searchValueForStockHolders: searchValueForStockHolders,
    });
  };

  onSearchForPendingPrimary = (searchValueForPendingPrimary) => {
    this.setState({
      searchValueForPendingPrimary: searchValueForPendingPrimary,
    });
  };

  onSearchForPerformingOutlets = (searchValueForOutlets) => {
    this.setState({
      searchValueForOutlets: searchValueForOutlets,
    });
  };

  onSearch = (searchValueForPendingBottomColumn) => {
    this.setState({
      searchValueForPendingBottomColumn: searchValueForPendingBottomColumn,
    });
  };

  getFilteredTableDataForTopPerformingOutlet = (searchData) => {
    const { searchValueForPending } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["firmName"] &&
          currentRow["firmName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPending.trim().toLowerCase())) ||
        (currentRow["ownerName"] &&
          currentRow["ownerName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPending.trim().toLowerCase())) ||
        (currentRow["beatName"] &&
          currentRow["beatName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPending.trim().toLowerCase())) ||
        (currentRow["totalAmt"] &&
          currentRow["totalAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPending.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  getFilteredTableDataForTopPerformingProductsSecondary = (searchData) => {
    const { searchValueForProduct } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProduct.trim().toLowerCase())) ||
        (currentRow["categoryName"] &&
          currentRow["categoryName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProduct.trim().toLowerCase())) ||
        (currentRow["subCategoryName"] &&
          currentRow["subCategoryName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProduct.trim().toLowerCase())) ||
        (currentRow["totalQty"] &&
          currentRow["totalQty"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProduct.trim().toLowerCase())) ||
        (currentRow["totalAmt"] &&
          currentRow["totalAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProduct.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  getFilteredTableDataForTopPerformingProductsPrimary = (searchData) => {
    const { searchValueForProductPrimary } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProductPrimary.trim().toLowerCase())) ||
        (currentRow["categoryName"] &&
          currentRow["categoryName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProductPrimary.trim().toLowerCase())) ||
        (currentRow["subCategoryName"] &&
          currentRow["subCategoryName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProductPrimary.trim().toLowerCase())) ||
        (currentRow["totalQty"] &&
          currentRow["totalQty"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProductPrimary.trim().toLowerCase())) ||
        (currentRow["totalAmt"] &&
          currentRow["totalAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProductPrimary.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  getFilteredTableDataForTopPerformingStakeHolders = (searchData) => {
    const { searchValueForStockHolders } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForStockHolders.trim().toLowerCase())) ||
        (currentRow["firmName"] &&
          currentRow["firmName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForStockHolders.trim().toLowerCase())) ||
        (currentRow["ownerName"] &&
          currentRow["ownerName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForStockHolders.trim().toLowerCase())) ||
        (currentRow["areaNames"] &&
          currentRow["areaNames"]
            .toString()
            .toLowerCase()
            .includes(searchValueForStockHolders.trim().toLowerCase())) ||
        (currentRow["totalOrder"] &&
          currentRow["totalOrder"]
            .toString()
            .toLowerCase()
            .includes(searchValueForStockHolders.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  getFilteredTableDataForPendingPrimary = (searchData) => {
    const { searchValueForPendingPrimary } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["orderDate"] &&
          currentRow["orderDate"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPendingPrimary.trim().toLowerCase())) ||
        (currentRow["orderNo"] &&
          currentRow["orderNo"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPendingPrimary.trim().toLowerCase())) ||
        (currentRow["fromOrderFirmName"] &&
          currentRow["fromOrderFirmName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPendingPrimary.trim().toLowerCase())) ||
        (currentRow["toOrderFirmName"] &&
          currentRow["toOrderFirmName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPendingPrimary.trim().toLowerCase())) ||
        (currentRow["taxableAmt"] &&
          currentRow["taxableAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPendingPrimary.trim().toLowerCase())) ||
        (currentRow["totalTax"] &&
          currentRow["totalTax"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPendingPrimary.trim().toLowerCase())) ||
        (currentRow["totalAmt"] &&
          currentRow["totalAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValueForPendingPrimary.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  getFilteredTableDataForPendingBillSecondary = (searchData) => {
    const { searchValueForOutlets } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["orderDate"] &&
          currentRow["orderDate"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase())) ||
        (currentRow["orderNo"] &&
          currentRow["orderNo"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase())) ||
        (currentRow["outletFirmName"] &&
          currentRow["outletFirmName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase())) ||
        (currentRow["toOrderFirmName"] &&
          currentRow["toOrderFirmName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase())) ||
        (currentRow["insertedUserPersonName"] &&
          currentRow["insertedUserPersonName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase())) ||
        (currentRow["taxableAmt"] &&
          currentRow["taxableAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase())) ||
        (currentRow["totalTax"] &&
          currentRow["totalTax"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase())) ||
        (currentRow["totalAmt"] &&
          currentRow["totalAmt"]
            .toString()
            .toLowerCase()
            .includes(searchValueForOutlets.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  generateExcel = () => {
    const { showLoador, showNotification } = this.props;
    const { dateForSalesTeamList } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        url:
          endpoint.adminDashboard +
          "/get-excel-sales-teams?fromDate=" +
          dayjs(dateForSalesTeamList).format("DD-MM-YYYY") +
          "&toDate=" +
          dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
        ext: "xlsx",
        openNewTab: true,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          this.props.showNotification({
            msg: serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  changeDateNew = (name) => (date) => {
    if (name === "dateForSalesTeamList") {
      this.setState({
        dateForSalesTeamList: date,
      });
    }
  };

  searchSalesTeamData = () => {
    const {
      getSalesTeamInfoByDatesWithAttendance,
      showLoador,
      showNotification,
      myConstClass,
    } = this.props;
    const { dateForSalesTeamList } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getSalesTeamInfoByDatesWithAttendance({
        fromDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
        toDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: response.serverMsg, severity: "error" });
        } else {
          let totalOutletCount = 0,
            zero = 0,
            productiveCall = 0,
            unvisited = 0,
            salesAmt = 0,
            totalAmount = 0,
            remoteOrder = 0;
          if (response.length !== 0) {
            response.map((salesTeam) => {
              totalOutletCount = totalOutletCount + +salesTeam.totalOutletCount;
              productiveCall = productiveCall + +salesTeam.productiveCall;
              zero = zero + +salesTeam.zeroOrderCount;
              unvisited = unvisited + +salesTeam.unvisitedOutletCount;
              salesAmt = salesAmt + +salesTeam.totalSalesAmt;
              totalAmount = totalAmount + +salesTeam.totalAmount;
              remoteOrder = remoteOrder + +salesTeam.remoteOrderCount;
            });
          }
          this.setState({
            totalOutletCount: totalOutletCount,
            zero: zero,
            productiveCall: productiveCall,
            unvisited: unvisited,
            salesAmt: salesAmt,
            totalAmount: totalAmount,
            remoteOrder: remoteOrder,
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  salesTeamHandler = (e, salesTeamId) => {
    const { getBeatFromSalesTeamId, showLoador, showNotification } = this.props;
    const { popUpFlag } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getBeatFromSalesTeamId({
        salesTeamIds: salesTeamId,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            beatPopupFlag: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  handleClosesSalesTeam = () => {
    this.setState({
      beatPopupFlag: false,
    });
  };

  getFilteredTableDataForSalesTeamList = (searchData) => {
    const { searchValueForSalesTeamList } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["district_names"] &&
          currentRow["district_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["area_names"] &&
          currentRow["area_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  handleChangeTabValue = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  onSearchForSalesTeamList = (searchValueForSalesTeamList) => {
    this.setState({
      searchValueForSalesTeamList: searchValueForSalesTeamList,
    });
  };

  render() {
    const {
      stockHolderSummaryList,
      salesDataMonthList,
      salesDataDateList,
      dashboardData2,
      beatList,
    } = this.props;
    const {
      saleMonth,
      pendingSaleMonth,
      datePending,
      topProductSaleMonth,
      onChangeFlag,
      refreshCardDateFlag,
      dateForSalesTeamList,
      formErrors,
      value,
      totalOutletCount,
      productiveCall,
      remoteOrder,
      unvisited,
      zero,
      totalAmount,
      salesAmt,
      beatPopupFlag,
    } = this.state;

    const stockHolderSummaryData = localStorage.getItem("stockHolderSummary");
    const stockHolderSummaryLocalStorage = JSON.parse(stockHolderSummaryData);

    const getPendingBillsData = localStorage.getItem("getPendingBills");
    const getPendingBillsLocalStorage = JSON.parse(getPendingBillsData);

    const getTopPerformingEntity = localStorage.getItem("getTopPerforming");
    const getTopPerformingEntitiesLocalStorage = JSON.parse(
      getTopPerformingEntity
    );

    return (
      <>
        <div
          id="layout-wrapper"
          style={{
            backgroundColor: "#fff",
          }}
        >
          {/* ========== App Menu ========== */}

          {/* Left Sidebar End */}
          {/* Vertical Overlay*/}
          <div className="vertical-overlay" />
          {/* ============================================================== */}
          {/* Start right Content here
            {/* ============================================================== */}
          <div className="main-content">
            <div className="page-content">
              <div className="container-fluid">
                <div
                  className="row"
                  style={{
                    gap: 20,
                    paddingBottom: 10,
                  }}
                >
                  <div style={{ paddingBottom: 10 }}>
                    <h1 style={{ marginBottom: 10 }}> </h1>
                  </div>

                  {/* Card New 1 Start */}
                  {(stockHolderSummaryLocalStorage
                    ? stockHolderSummaryLocalStorage?.outletCount
                    : stockHolderSummaryList?.stockHolder?.outletCount) !==
                    0 && (
                      <div
                        style={{
                          backgroundColor: "white",
                          flex: "1 1 250px",
                          minWidth: "250px",
                          maxWidth: "300px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          borderRadius: "12px",
                          padding: "20px",
                          gap: "20px",
                          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        }}
                      >
                        <div
                          style={{
                            width: "80px",
                            height: "80px",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "15%",
                              backgroundImage:
                                "linear-gradient(to right, #00b1ff , #baeaff)",
                              position: "absolute",
                              objectFit: "contain",
                              padding: "10px",
                            }}
                            src={store}
                            alt=""
                          />
                        </div>

                        <div
                          style={{
                            isplay: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            gap: "10px",
                            paddingRight: "6px",
                          }}
                        >
                          <div style={{ fontSize: "18px" }}>OUTLET COUNT</div>
                          <div style={{ fontSize: "28px" }}>
                            {stockHolderSummaryLocalStorage
                              ? stockHolderSummaryLocalStorage?.outletCount
                              : stockHolderSummaryList?.stockHolder?.outletCount}
                          </div>
                        </div>
                      </div>
                    )}
                  {/* Card New 1 end */}

                  {/* Card New 2 start */}
                  {(stockHolderSummaryLocalStorage
                    ? stockHolderSummaryLocalStorage?.stockStakeHolderCount
                    : stockHolderSummaryList?.stockHolder
                      ?.stockStakeHolderCount) !== 0 && (
                      <div
                        style={{
                          backgroundColor: "white",
                          flex: "1 1 250px",
                          minWidth: "250px",
                          maxWidth: "300px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          borderRadius: "12px",
                          padding: "20px",
                          gap: "20px",
                          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        }}
                      >
                        <div
                          style={{
                            width: "80px",
                            height: "80px",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "15%",
                              backgroundImage:
                                "linear-gradient(to right, #00b1ff , #baeaff)",
                              position: "absolute",
                              objectFit: "contain",
                              padding: "10px",
                            }}
                            src={workers}
                            alt=""
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "-webkit-fill-available",
                            gap: "10px",
                            paddingRight: "6px",
                          }}
                        >
                          <div style={{ fontSize: "16px" }}>
                            STOCK HOLDER COUNT
                          </div>
                          <div style={{ fontSize: "28px" }}>
                            {" "}
                            {stockHolderSummaryLocalStorage
                              ? stockHolderSummaryLocalStorage?.stockStakeHolderCount
                              : stockHolderSummaryList?.stockHolder
                                ?.stockStakeHolderCount}
                          </div>
                        </div>
                      </div>
                    )}

                  {/* Card New 2 end */}

                  {/* Card New 3 start */}
                  {(stockHolderSummaryLocalStorage
                    ? stockHolderSummaryLocalStorage?.salesTeamCount
                    : stockHolderSummaryList?.stockHolder?.salesTeamCount) !==
                    0 && (
                      <div
                        style={{
                          backgroundColor: "white",
                          flex: "1 1 250px",
                          minWidth: "250px",
                          maxWidth: "300px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          borderRadius: "12px",
                          padding: "20px",
                          gap: "20px",
                          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        }}
                      >
                        <div
                          style={{
                            width: "80px",
                            height: "80px",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "15%",
                              backgroundImage:
                                "linear-gradient(to right, #00b1ff , #baeaff)",
                              position: "absolute",
                              objectFit: "contain",
                              padding: "10px",
                            }}
                            src={workers}
                            alt=""
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            gap: "10px",
                            paddingRight: "6px",
                          }}
                        >
                          <div style={{ fontSize: "16px" }}>SALES TEAM COUNT</div>
                          <div style={{ fontSize: "28px" }}>
                            {stockHolderSummaryLocalStorage
                              ? stockHolderSummaryLocalStorage?.salesTeamCount
                              : stockHolderSummaryList?.stockHolder
                                ?.salesTeamCount}
                          </div>
                        </div>
                      </div>
                    )}

                  {/* Card New 3 end */}

                  {/* Card New 4 start */}
                  {(stockHolderSummaryLocalStorage
                    ? stockHolderSummaryLocalStorage?.vehicleCount
                    : stockHolderSummaryList?.stockHolder?.vehicleCount) !==
                    0 && (
                      <div
                        style={{
                          backgroundColor: "white",
                          flex: "1 1 250px",
                          minWidth: "250px",
                          maxWidth: "300px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          borderRadius: "12px",
                          padding: "20px",
                          gap: "20px",
                          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        }}
                      >
                        <div
                          style={{
                            width: "80px",
                            height: "80px",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "15%",
                              backgroundImage:
                                "linear-gradient(to right, #00b1ff , #baeaff)",
                              position: "absolute",
                              objectFit: "contain",
                              padding: "10px",
                            }}
                            src={vehicle}
                            alt=""
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            gap: "10px",
                            paddingRight: "6px",
                          }}
                        >
                          <div style={{ fontSize: "18px" }}>VEHICLE COUNT</div>
                          <div style={{ fontSize: "28px" }}>
                            {stockHolderSummaryLocalStorage
                              ? stockHolderSummaryLocalStorage?.vehicleCount
                              : stockHolderSummaryList?.stockHolder?.vehicleCount}
                          </div>
                        </div>
                      </div>
                    )}
                </div>

                <hr style={{ borderTop: "1px solid #ccc", margin: "10px 0" }} />

                <div
                  className="row"
                  style={{
                    gap: 8,
                    marginBottom: 10,
                    width: "100%",
                    // marginTop: 15
                  }}
                ></div>
              </div>

              {/* MTD and Todays New Start Here with toggle */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: "15px",
                  gap: "16px",
                  flexWrap: "wrap",
                  flexShrink: 0,
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    margin: 0,
                    minWidth: "100px",
                    flexShrink: 0,
                  }}
                >
                  {this.state.count === 0 ? "MTD" : "TODAY'S"}
                </Typography>

                <ToggleButtonGroup
                  value={this.state.count}
                  exclusive
                  onChange={(event, newValue) => {
                    if (newValue !== null) {
                      this.setState(
                        {
                          count: newValue,
                          onChangeFlag: false,
                        },
                        () => {
                          const { pendingSaleMonth, topProductSaleMonth } =
                            this.state;
                          if (newValue === 0 && pendingSaleMonth) {
                            this.onDateChangeMtd(
                              pendingSaleMonth,
                              "pendingSaleMonth"
                            );
                          } else if (newValue === 1 && topProductSaleMonth) {
                            this.onDateChangeMtd(
                              topProductSaleMonth,
                              "topProductSaleMonth"
                            );
                          }
                        }
                      );
                    }
                  }}
                  size="small"
                  color="primary"
                  style={{
                    flexShrink: 0,
                    minWidth: "200px",
                  }}
                >
                  <ToggleButton value={0}>MTD</ToggleButton>
                  <ToggleButton value={1}>TODAY'S</ToggleButton>
                </ToggleButtonGroup>

                <div
                  style={{
                    width: "200px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0,
                    marginRight: "13px",
                  }}
                >
                  {this.state.count === 0 ? (
                    <MonthCalender
                      title=""
                      name="pendingSaleMonth"
                      value={pendingSaleMonth}
                      onChange={this.onDateChangeMtd}
                      sx={{ width: "100%", paddingBottom: 4 }}
                    />
                  ) : (
                    <BasicDatePicker
                      color="primary"
                      name="topProductSaleMonth"
                      size="small"
                      value={topProductSaleMonth}
                      disabled={false}
                      fullWidth
                      onChange={(newDate) =>
                        this.onDateChangeMtd(newDate, "topProductSaleMonth")
                      }
                      sx={{ width: "100%", paddingBottom: 0 }}
                    />
                  )}
                </div>
              </div>

              {/* MTD Section */}
              {this.state.count === 0 && (
                <>
                  {/* MTD Cards */}
                  <div
                    className="row"
                    style={{
                      gap: 20,
                      marginLeft: "15px",
                      marginRight: "15px",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {/* MTD Cards  */}
                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthSalesAmtPrimary != null &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthSalesAmtPrimary !== 0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthSalesAmtPrimary != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthSalesAmtPrimary !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={sales}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              PRIMARY SALES
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? salesDataMonthList?.salesDataByMonth
                                  ?.currentMonthSalesAmtPrimary
                                : stockHolderSummaryLocalStorage?.currentMonthSalesAmtPrimary ||
                                stockHolderSummaryList?.stockHolder
                                  ?.currentMonthSalesAmtPrimary
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthOrderAmtPrimary != null &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthOrderAmtPrimary !== 0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthOrderAmtPrimary != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthOrderAmtPrimary !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={ShoppingTrolly}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              PRIMARY ORDER
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? Math.round(salesDataMonthList?.salesDataByMonth
                                  ?.currentMonthOrderAmtPrimary)
                                : Math.round(stockHolderSummaryLocalStorage?.currentMonthOrderAmtPrimary ||
                                  stockHolderSummaryList?.stockHolder
                                    ?.currentMonthOrderAmtPrimary)
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthSalesAmtSecondary != null &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthSalesAmtSecondary !== 0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthSalesAmtSecondary != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthSalesAmtSecondary !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={sales}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              SECONDARY SALES
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? salesDataMonthList?.salesDataByMonth
                                  ?.currentMonthSalesAmtSecondary
                                : stockHolderSummaryLocalStorage?.currentMonthSalesAmtSecondary ||
                                stockHolderSummaryList?.stockHolder
                                  ?.currentMonthSalesAmtSecondary
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthOrderAmtSecondary != null &&
                      salesDataMonthList?.salesDataByMonth
                        ?.currentMonthOrderAmtSecondary !== 0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthOrderAmtSecondary != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthOrderAmtSecondary !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={ShoppingTrolly}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              SECONDARY ORDER
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? salesDataMonthList?.salesDataByMonth
                                  ?.currentMonthOrderAmtSecondary
                                : stockHolderSummaryLocalStorage?.currentMonthOrderAmtSecondary ||
                                stockHolderSummaryList?.stockHolder
                                  ?.currentMonthOrderAmtSecondary
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth?.grnAmt != null &&
                      salesDataMonthList?.salesDataByMonth?.grnAmt !== 0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthGrnAmt != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthGrnAmt !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={grnLogo1}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              GRN AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? Math.round(salesDataMonthList?.salesDataByMonth?.grnAmt)
                                : Math.round(stockHolderSummaryLocalStorage?.currentMonthGrnAmt) ||
                                Math.round(stockHolderSummaryList?.stockHolder
                                  ?.currentMonthGrnAmt)
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth?.crnAmt != null &&
                      salesDataMonthList?.salesDataByMonth?.crnAmt !== 0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthCrnAmt != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthCrnAmt !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={checklist}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              CREDIT NOTE AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? salesDataMonthList?.salesDataByMonth?.crnAmt
                                : stockHolderSummaryLocalStorage?.currentMonthCrnAmt ||
                                stockHolderSummaryList?.stockHolder
                                  ?.currentMonthCrnAmt
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth?.selfCrnAmt !=
                      null &&
                      salesDataMonthList?.salesDataByMonth?.selfCrnAmt !== 0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthSelfCrnAmt != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthSelfCrnAmt !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={crnLogo}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              SELF CRN AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? salesDataMonthList?.salesDataByMonth?.selfCrnAmt
                                : stockHolderSummaryLocalStorage?.currentMonthSelfCrnAmt ||
                                stockHolderSummaryList?.stockHolder
                                  ?.currentMonthSelfCrnAmt
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((onChangeFlag &&
                      salesDataMonthList?.salesDataByMonth?.outletCrnAmt !=
                      null &&
                      salesDataMonthList?.salesDataByMonth?.outletCrnAmt !==
                      0) ||
                      (!onChangeFlag &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthOutletCrnAmt != null &&
                        stockHolderSummaryList?.stockHolder
                          ?.currentMonthOutletCrnAmt !== 0)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={crnLogo}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              OUTLET CRN AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {(onChangeFlag
                                ? salesDataMonthList?.salesDataByMonth
                                  ?.outletCrnAmt
                                : stockHolderSummaryLocalStorage?.currentMonthOutletCrnAmt ||
                                stockHolderSummaryList?.stockHolder
                                  ?.currentMonthOutletCrnAmt
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </>
              )}

              {/* TODAY Section */}
              {this.state.count === 1 && (
                <>
                  {/* Today Cards */}
                  <div
                    className="row"
                    style={{
                      gap: 20,
                      marginLeft: "15px",
                      marginRight: "15px",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {/*  TODAY Cards  */}

                    {((stockHolderSummaryList?.stockHolder
                      .currentDateSalesAmtPrimary !== 0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate
                        ?.currentMonthSalesAmtPrimary !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={sales}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              PRIMARY SALES
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                this.state.refreshCardDateFlag
                                  ? salesDataDateList?.salesDataByDate
                                    ?.currentMonthSalesAmtPrimary
                                  : stockHolderSummaryList?.stockHolder
                                    ?.currentDateSalesAmtPrimary
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((stockHolderSummaryList?.stockHolder
                      .currentDateOrderAmtPrimary !== 0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate
                        ?.currentMonthOrderAmtPrimary !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={ShoppingTrolly}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              PRIMARY ORDER
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                Math.round(this.state.refreshCardDateFlag
                                  ? salesDataDateList?.salesDataByDate
                                    ?.currentMonthOrderAmtPrimary
                                  : stockHolderSummaryList?.stockHolder
                                    ?.currentDateOrderAmtPrimary)
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((stockHolderSummaryList?.stockHolder
                      .currentDateSalesAmtSecondary !== 0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate
                        ?.currentMonthSalesAmtSecondary !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={sales}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              SECONDARY SALES
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                this.state.refreshCardDateFlag
                                  ? salesDataDateList?.salesDataByDate
                                    ?.currentMonthSalesAmtSecondary
                                  : stockHolderSummaryList?.stockHolder
                                    ?.currentDateSalesAmtSecondary
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((stockHolderSummaryList?.stockHolder
                      .currentDateOrderAmtSecondary !== 0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate
                        ?.currentMonthOrderAmtSecondary !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={ShoppingTrolly}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              SECONDARY ORDER
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                this.state.refreshCardDateFlag
                                  ? salesDataDateList?.salesDataByDate
                                    ?.currentMonthOrderAmtSecondary
                                  : stockHolderSummaryList?.stockHolder
                                    ?.currentDateOrderAmtSecondary
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((stockHolderSummaryList?.stockHolder.currentDateGrnAmt !==
                      0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate?.grnAmt !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={grnLogo1}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              GRN AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                this.state.refreshCardDateFlag
                                  ? Math.round(salesDataDateList?.salesDataByDate?.grnAmt)
                                  : Math.round(stockHolderSummaryList?.stockHolder
                                    ?.currentDateGrnAmt)
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((stockHolderSummaryList?.stockHolder.currentDateCrnAmt !==
                      0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate?.crnAmt !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={checklist}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              CREDIT NOTE AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                this.state.refreshCardDateFlag
                                  ? salesDataDateList?.salesDataByDate?.crnAmt
                                  : stockHolderSummaryList?.stockHolder
                                    ?.currentDateCrnAmt
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((stockHolderSummaryList?.stockHolder
                      .currentDateSelfCrnAmt !== 0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate?.selfCrnAmt !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={crnLogo}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              SELF CRN AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                this.state.refreshCardDateFlag
                                  ? salesDataDateList?.salesDataByDate?.selfCrnAmt
                                  : stockHolderSummaryList?.stockHolder
                                    ?.currentDateSelfCrnAmt
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                    {((stockHolderSummaryList?.stockHolder
                      .currentDateOutletCrnAmt !== 0 &&
                      !onChangeFlag) ||
                      (salesDataDateList?.salesDataByDate?.outletCrnAmt !== 0 &&
                        onChangeFlag)) && (
                        <div
                          style={{
                            backgroundColor: "white",
                            flex: "1 1 250px",
                            minWidth: "250px",
                            maxWidth: "300px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            borderRadius: "12px",
                            padding: "20px",
                            gap: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "15%",
                                backgroundImage:
                                  "linear-gradient(to right, #00b1ff , #baeaff)",
                                position: "absolute",
                                objectFit: "contain",
                                padding: "10px",
                              }}
                              src={crnLogo}
                              alt=""
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                              gap: "10px",
                              paddingRight: "6px",
                            }}
                          >
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              OUTLET CRN AMOUNT
                            </div>
                            <div style={{ fontSize: "24px" }}>
                              {Number(
                                this.state.refreshCardDateFlag
                                  ? salesDataDateList?.salesDataByDate
                                    ?.outletCrnAmt
                                  : stockHolderSummaryList?.stockHolder
                                    ?.currentDateOutletCrnAmt
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </>
              )}

              {/* MTD and Todays New End Here with toggle */}

              <hr style={{ borderTop: "1px solid #ccc", margin: "13px 0" }} />

              <br />

              {/* PENDING ORDERS Header Row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: "15px",
                }}
              >
                <Typography variant="h5" style={{ margin: 0 }}>
                  PENDING ORDERS
                </Typography>

                <MonthCalender
                  title=""
                  name="datePending"
                  value={datePending}
                  onChange={this.onDateChangePending}
                  sx={{
                    paddingBottom: 0,
                  }}
                />
              </div>

              {/* Tables Row */}

              <div>
                {getPendingBillsLocalStorage?.currentMonthPendingBillsPrimary
                  ?.length > 0 && (
                    <div>
                      <div
                        className="row"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          gap: 10,
                          marginBottom: 10,
                          width: "100%",
                          marginLeft: 5,
                          marginRight: 5,
                        }}
                      >
                        {/* Primary Table Card */}
                        <div
                          style={{
                            width: "97%",
                            background: "white",
                            padding: '10px',
                            borderRadius: 8,
                            border: "1px #E6E6E6 solid",
                            marginLeft: "10px",
                          }}
                        >
                          {/* Inner Card */}
                          <div
                            style={{
                              marginBottom: -2,
                              background: "white",
                              borderRadius: 8,
                              border: "0 #E6E6E6 solid",
                            }}
                          >
                            <div
                              className="card-header align-items-center d-flex"
                              style={{
                                background: "white",
                                borderRadius: 8,
                                border: "0 #E6E6E6 solid",
                              }}
                            >
                              <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                Primary
                                <div style={{ marginLeft: -25 }}>
                                  <br />
                                  <LandingScreenHeader
                                    screenTitle={""}
                                    showSearchBox={true}
                                    showTable={true}
                                    showFilter={false}
                                    showPdfDownload={false}
                                    showExcelDownload={false}
                                    onSearch={this.onSearchForPendingPrimary}
                                  />
                                </div>
                              </h4>
                              {/* )} */}
                            </div>
                          </div>

                          <RTTable
                            columns={[
                              {
                                name: "index",
                                title: "Sr. No.",
                                align: "center",
                              },
                              {
                                name: "orderDate",
                                title: "Order Date",
                                align: "center",
                              },
                              {
                                name: "orderNo",
                                title: "Order No",
                                align: "center",
                              },
                              {
                                name: "fromOrderFirmName",
                                title: "Order From",
                              },
                              {
                                name: "toOrderFirmName",
                                title: "Order To",
                              },

                              {
                                name: "taxableAmt",
                                title: " Taxable Amt",
                                align: "right",
                              },
                              {
                                name: "totalTax",
                                title: " Total Tax Amt",
                                align: "right",
                              },

                              {
                                name: "totalAmt",
                                title: " Total Amt ",
                                align: "right",
                              },
                            ]}
                            tableData={this.getFilteredTableDataForPendingPrimary(
                              getPendingBillsLocalStorage
                                ? getPendingBillsLocalStorage.currentMonthPendingBillsPrimary
                                : []
                            )}
                            isActionColActive={false}
                            showPegination={false}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                {/* Secondary Table */}
                {getPendingBillsLocalStorage?.currentMonthPendingBillsSecondary
                  ?.length > 0 && (
                    <div
                      style={{
                        width: "97%",
                        background: "white",
                        padding: "10px",
                        borderRadius: 8,
                        border: "1px #E6E6E6 solid",
                        marginLeft: "15px"
                      }}
                    >
                      <div
                        style={{
                          marginBottom: -2,
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                        }}
                      >
                        <div
                          className="card-header align-items-center d-flex"
                          style={{
                            background: "white",
                            borderRadius: 8,
                            border: "0 #E6E6E6 solid",
                          }}
                        >
                          <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                            Secondary
                            <div style={{ marginLeft: -25 }}>
                              <br />
                              <LandingScreenHeader
                                screenTitle={""}
                                showSearchBox={true}
                                showTable={true}
                                showFilter={false}
                                showPdfDownload={false}
                                showExcelDownload={false}
                                onSearch={this.onSearchForPerformingOutlets}
                              />
                            </div>
                          </h4>
                        </div>
                      </div>

                      <TableContainer
                        sx={{
                          maxHeight: 440,
                          marginTop: 0,
                          padding: 1.5,
                        }}
                      >
                        <RTTable
                          columns={[
                            {
                              name: "index",
                              title: "Sr. No.",
                              align: "center",
                            },
                            {
                              name: "orderDate",
                              title: "Order Date",
                              align: "center",
                            },
                            {
                              name: "orderNo",
                              title: "Order No",
                              align: "center",
                            },

                            {
                              name: "outletFirmName",
                              title: " Outlet Name ",
                            },
                            {
                              name: "toOrderFirmName",
                              title: "Order To",
                            },
                            {
                              name: "insertedUserPersonName",
                              title: "Sales Person Name",
                            },
                            {
                              name: "taxableAmt",
                              title: "Taxable Amt",
                              align: "right",
                            },

                            {
                              name: "totalTax",
                              title: "Total Tax Amt",
                              align: "right",
                            },
                            {
                              name: "totalAmt",
                              title: "Total Amt",
                              align: "right",
                            },
                          ]}
                          tableData={this.getFilteredTableDataForPendingBillSecondary(
                            getPendingBillsLocalStorage
                              ? getPendingBillsLocalStorage.currentMonthPendingBillsSecondary
                              : []
                          )}
                          isActionColActive={false}
                          showPegination={false}
                        />
                      </TableContainer>
                    </div>
                  )}
              </div>

              <hr style={{ borderTop: "1px solid #ccc", margin: "10px 0" }} />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: "15px",
                }}
              >
                <Typography variant="h5" style={{ margin: 0 }}>
                  TOP PERFORMANCE
                </Typography>

                <MonthCalender
                  title=""
                  name="saleMonth"
                  value={saleMonth}
                  onChange={this.onDateChangePerformance}
                  sx={{
                    paddingBottom: 0,
                  }}
                />
              </div>

              {/* Tables Row */}

              <div>
                {getTopPerformingEntitiesLocalStorage?.productListPrimary
                  ?.length > 0 && (
                    <div
                      className="row"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: 10,
                        marginBottom: 10,
                        width: "100%",
                        marginLeft: 5,
                        marginRight: 5,
                      }}
                    >
                      <div
                        style={{
                          width: "97%",
                          background: "white",
                          padding: "10px",
                          borderRadius: 8,
                          border: "1px #E6E6E6 solid",
                          marginLeft: "10px"
                        }}
                      >
                        <div
                          style={{
                            marginBottom: -2,
                            background: "white",
                            borderRadius: 8,
                            border: "0 #E6E6E6 solid",
                          }}
                        >
                          <div
                            className="card-header align-items-center d-flex"
                            style={{
                              background: "white",
                              borderRadius: 8,
                              border: "0 #E6E6E6 solid",
                            }}
                          >
                            <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                              TOP 20 PRODUCT : BILLWISE (PRIMARY)
                              <div style={{ marginLeft: -25 }}>
                                <br />
                                <LandingScreenHeader
                                  screenTitle={""}
                                  showSearchBox={true}
                                  showTable={true}
                                  showFilter={false}
                                  showPdfDownload={false}
                                  showExcelDownload={false}
                                  onSearch={
                                    this.onSearchForPerformingProductPrimary
                                  }
                                />
                              </div>
                            </h4>
                          </div>
                        </div>

                        <RTTable
                          columns={[
                            { name: "index", title: "Sr. No.", align: "center" },
                            { name: "name", title: "Product Name" },
                            {
                              name: "categoryName",
                              title: "Category Name ",
                            },
                            {
                              name: "subCategoryName",
                              title: "Sub Category Name",
                            },
                            {
                              name: "totalQty",
                              title: "Total Qty",
                              align: "right",
                            },
                            {
                              name: "totalAmt",
                              title: "Total Amt",
                              align: "right",
                            },
                          ]}
                          tableData={this.getFilteredTableDataForTopPerformingProductsPrimary(
                            getTopPerformingEntitiesLocalStorage
                              ? getTopPerformingEntitiesLocalStorage?.productListPrimary
                              : []
                          )}
                          isActionColActive={false}
                          showPegination={false}
                        />
                      </div>
                    </div>
                  )}

                {/* Secondary Table  */}

                {getTopPerformingEntitiesLocalStorage?.productListSecondary
                  ?.length > 0 && (
                    <div
                      style={{
                        width: "97%",
                        background: "white",
                        padding: "10px",
                        borderRadius: 8,
                        border: "1px #E6E6E6 solid",
                        marginLeft: "15px",
                      }}
                    >
                      <div
                        style={{
                          marginBottom: -2,
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                        }}
                      >
                        <div
                          className="card-header align-items-center d-flex"
                          style={{
                            background: "white",
                            borderRadius: 8,
                            border: "0 #E6E6E6 solid",
                          }}
                        >
                          <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                            TOP 20 PRODUCT : BILLWISE (SECONDARY)
                            <div style={{ marginLeft: -10 }}>
                              <br />
                              <LandingScreenHeader
                                screenTitle={""}
                                showSearchBox={true}
                                showTable={true}
                                showFilter={false}
                                showPdfDownload={false}
                                showExcelDownload={false}
                                onSearch={this.onSearchForPerformingProducts}
                              />
                            </div>
                          </h4>
                        </div>
                      </div>

                      <TableContainer
                        sx={{
                          maxHeight: 440,
                          marginTop: -2,
                          padding: 1.5,
                        }}
                      >
                        <RTTable
                          columns={[
                            { name: "index", title: "Sr. No.", align: "center" },
                            { name: "name", title: " Product Name" },
                            { name: "categoryName", title: " Category" },
                            { name: "subCategoryName", title: "Sub Category" },
                            {
                              name: "totalQty",
                              title: "Total Qty",
                              align: "right",
                            },
                            {
                              name: "totalAmt",
                              title: "Total Amt",
                              align: "right",
                            },
                          ]}
                          tableData={this.getFilteredTableDataForTopPerformingProductsSecondary(
                            getTopPerformingEntitiesLocalStorage
                              ? getTopPerformingEntitiesLocalStorage?.productListSecondary
                              : []
                          )}
                          isActionColActive={false}
                          showPegination={false}
                        />
                      </TableContainer>
                    </div>
                  )}
              </div>

              <hr style={{ borderTop: "1px solid #ccc", margin: "13px 0" }} />

              <div>
                {getTopPerformingEntitiesLocalStorage?.stockStakeHolders
                  ?.length > 0 && (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          margin: "15px",
                        }}
                      ></div>

                      {/* Tables Row */}
                      <div
                        className="row"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          gap: 10,
                          marginBottom: 10,
                          width: "100%",
                          marginLeft: 5,
                          marginRight: 5,
                        }}
                      >
                        <div
                          style={{
                            width: "97%",
                            background: "white",
                            padding: 10,
                            borderRadius: 8,
                            border: "1px #E6E6E6 solid",
                            marginLeft: "10px"
                          }}
                        >
                          <div
                            style={{
                              marginBottom: -2,
                              background: "white",
                              borderRadius: 8,
                              border: "0 #E6E6E6 solid",
                            }}
                          >
                            <div
                              className="card-header align-items-center d-flex"
                              style={{
                                background: "white",
                                borderRadius: 8,
                                border: "0 #E6E6E6 solid",
                              }}
                            >
                              <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                TOP 20 Stock Holders BILLWISE
                                <div style={{ marginLeft: -25 }}>
                                  <br />
                                  <LandingScreenHeader
                                    screenTitle={""}
                                    showSearchBox={true}
                                    showTable={true}
                                    showFilter={false}
                                    showPdfDownload={false}
                                    showExcelDownload={false}
                                    onSearch={
                                      this.onSearchForPerformingStockHolders
                                    }
                                  />
                                </div>
                              </h4>
                            </div>
                          </div>

                          <RTTable
                            columns={[
                              {
                                name: "index",
                                title: "Sr. No.",
                                align: "center",
                              },
                              { name: "name", title: "Stock Holder Type" },
                              {
                                name: "firmName",
                                title: "Firm Name",
                              },
                              {
                                name: "ownerName",
                                title: "Owner Name",
                              },
                              {
                                name: "areaNames",
                                title: "Area Name",
                              },
                              {
                                name: "totalOrder",
                                title: "Total Order",
                                align: "right",
                              },
                            ]}
                            tableData={this.getFilteredTableDataForTopPerformingStakeHolders(
                              getTopPerformingEntitiesLocalStorage
                                ? getTopPerformingEntitiesLocalStorage?.stockStakeHolders
                                : []
                            )}
                            isActionColActive={false}
                            showPegination={false}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                {getTopPerformingEntitiesLocalStorage?.outletList?.length >
                  0 && (
                    <div
                      style={{
                        width: "97%",
                        background: "white",
                        padding: "10px",
                        borderRadius: 8,
                        border: "1px #E6E6E6 solid",
                        marginLeft: "15px"
                      }}
                    >
                      <div
                        style={{
                          marginBottom: -2,
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                        }}
                      >
                        <div
                          className="card-header align-items-center d-flex"
                          style={{
                            background: "white",
                            borderRadius: 8,
                            border: "0 #E6E6E6 solid",
                          }}
                        >
                          <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                            Top 20 Outlets BILLWISE
                            <div style={{ marginLeft: -10 }}>
                              <br />
                              <LandingScreenHeader
                                screenTitle={""}
                                showSearchBox={true}
                                showTable={true}
                                showFilter={false}
                                showPdfDownload={false}
                                showExcelDownload={false}
                                onSearch={this.onSearchForPedning}
                              />
                            </div>
                          </h4>
                        </div>
                      </div>

                      <TableContainer
                        sx={{
                          maxHeight: 440,
                          marginTop: -2,
                          padding: 1.5,
                        }}
                      >
                        <RTTable
                          columns={[
                            { name: "index", title: "Sr. No.", align: "center" },
                            { name: "firmName", title: " Outlet Name" },
                            { name: "ownerName", title: " Owner Name" },
                            {
                              name: "beatName",
                              title: "Beat Name",
                            },

                            {
                              name: "totalAmt",
                              title: "Total Amt",
                              align: "right",
                            },
                          ]}
                          tableData={this.getFilteredTableDataForTopPerformingOutlet(
                            getTopPerformingEntitiesLocalStorage
                              ? getTopPerformingEntitiesLocalStorage?.outletList
                              : []
                          )}
                          isActionColActive={false}
                          showPegination={false}
                        />
                      </TableContainer>
                    </div>
                  )}
              </div>

              <hr style={{ borderTop: "1px solid #ccc", margin: "13px 0" }} />

              <div
                className="row"
                style={{
                  gap: 8,
                  marginBottom: 10,
                  width: "100%",
                  marginLeft: 5,
                }}
              >
                <div
                  style={{
                    width: "97%",
                    background: "white",
                    padding: 5,
                    borderRadius: 8,
                    border: "1px #E6E6E6 solid",
                    marginLeft: "10px",
                  }}
                >
                  {/* Top beat starts */}
                  {/* 8 may changes  */}
                  <div
                    // className="card"
                    style={{
                      marginBottom: -2,
                      background: "white",
                      borderRadius: 8,
                      border: "0 #E6E6E6 solid",
                    }}
                  >
                    <div
                      className="card-header align-items-center d-flex"
                      style={{
                        background: "white",
                        borderRadius: 8,
                        border: "0 #E6E6E6 solid",
                        // marginTop: 20,
                      }}
                    >
                      <h4
                        className="text-uppercase card-title mb-0 flex-grow-1"
                        style={{}}
                      >
                        Sales Team List
                        <div
                          style={{
                            marginLeft: -20,
                          }}
                        >
                          <LandingScreenHeader
                            screenTitle={""}
                            showSearchBox={true}
                            showTable={true}
                            showFilter={false}
                            showPdfDownload={false}
                            showExcelDownload={false}
                            generateExcel={this.generateExcel}
                            onSearch={this.onSearchForSalesTeamList}
                          />
                        </div>
                      </h4>
                      <h4
                        className="text-uppercase card-title mb-0 flex-grow-1"
                        style={{
                          textAlign: "center",
                          width: "300px",
                        }}
                      >
                        <Grid
                          item
                          sm={12}
                          xs={12}
                          md={12}
                          lg={12}
                          container
                          justifyContent="end"
                          flexWrap={"wrap"}
                        >
                          <Grid
                            item
                            sm={12}
                            xs={12}
                            md={8}
                            lg={8}
                            container
                            justifyContent="space-evenly"
                          >
                            <Grid
                              item
                              xs={12}
                              md={2}
                              sm={12}
                              flexDirection={"row"}
                              display={"flex"}
                            >
                              <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16, color: redColor }}
                                label="* "
                              />
                              <LabelCompo
                                className="text-black"
                                style={{
                                  fontSize: 16,
                                  color: titleColor,
                                  marginTop: "5px",
                                  marginRight: "8px",
                                }}
                                label="Date :"
                              />
                            </Grid>
                            <Grid item xs={12} md={7} sm={7}>
                              <BasicDatePicker
                                color="primary"
                                name="dateForSalesTeamList"
                                size="small"
                                value={dateForSalesTeamList}
                                disabled={false}
                                fullWidth
                                onChange={this.changeDateNew(
                                  "dateForSalesTeamList"
                                )}
                                errorText={
                                  formErrors["dateForSalesTeamListError"]
                                    ? formErrors["dateForSalesTeamListError"]
                                    : ""
                                }
                                isError={
                                  formErrors["dateForSalesTeamListError"]
                                    ? formErrors["dateForSalesTeamListError"]
                                    : ""
                                }
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            sm={12}
                            xs={12}
                            md={4}
                            lg={4}
                            gap={2}
                            container
                            display={"flex"}
                            flexDirection="row"
                            justifyContent="end"
                            alignItems="center"
                          >
                            <ButtonCompo
                              sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                                height: "40px",
                                width: "100px",
                                lineHeight: "1.5",
                              }}
                              size="medium"
                              type="button"
                              variant="contained"
                              name={"Search"}
                              onClick={this.searchSalesTeamData}
                            />

                            <ButtonCompo
                              sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                                height: "40px",
                                width: "100px",
                                lineHeight: "1.5",
                              }}
                              size="medium"
                              type="button"
                              variant="contained"
                              name={"Excel"}
                              onClick={this.generateExcel}
                            />
                          </Grid>
                        </Grid>
                      </h4>
                    </div>
                  </div>

                  <Tabs
                    value={value}
                    onChange={this.handleChangeTabValue}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable force tabs example"
                    sx={{
                      "& .MuiTab-root": { marginRight: "15px" },
                    }}
                  >
                    <Tab
                      value="0"
                      label={
                        "All" + " ( " + dashboardData2?.salesInfo.length + " ) "
                      }
                    />
                    <Tab
                      value="1"
                      label={
                        "Present" +
                        " ( " +
                        dashboardData2?.salesInfo.filter(
                          (row) => row.attendenceStatus == 1
                        ).length +
                        " ) "
                      }
                    />
                    <Tab
                      value="2"
                      label={
                        "Absent" +
                        " ( " +
                        dashboardData2?.salesInfo.filter(
                          (row) => row.attendenceStatus == 0
                        ).length +
                        " ) "
                      }
                    />
                    <Tab
                      value="3"
                      label={
                        "Late" +
                        " ( " +
                        dashboardData2?.salesInfo.filter(
                          (row) => row.checkInStatus == 1
                        ).length +
                        " ) "
                      }
                    />
                  </Tabs>

                  <br />

                  <TableContainer
                    sx={{
                      maxHeight: 440,
                      // width: 610,
                      // padding: 1.5,
                      // marginTop: 2.5,
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <TableRow>
                          <TableCell
                            color="#000"
                            align="center"
                            sx={{ width: "1%", color: "#000" }}
                            canSearch="true"
                          >
                            Sr.No
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "5%", color: "#000" }}
                            canSearch="true"
                          >
                            Sales Team Name
                          </TableCell>

                          {localStorage.getItem(
                            "showAreaDistrictColumnsOnSalesTeamListDashboard"
                          ) &&
                            localStorage.getItem(
                              "showAreaDistrictColumnsOnSalesTeamListDashboard"
                            ) == 1 && (
                              <>
                                <TableCell
                                  align="center"
                                  sx={{ width: "2%", color: "#000" }}
                                  canSearch="true"
                                >
                                  District
                                </TableCell>

                                <TableCell
                                  align="center"
                                  sx={{ width: "15%", color: "#000" }}
                                  canSearch="true"
                                >
                                  Area
                                </TableCell>
                              </>
                            )}

                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Beat Count
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Total Outlet
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Productive Call
                          </TableCell>
                          {localStorage.getItem("isShowRemoteOrderColumnAtAnalyticalDashboard") &&
                            localStorage.getItem("isShowRemoteOrderColumnAtAnalyticalDashboard") == 1 && (
                              <TableCell
                                align="center"
                                sx={{ width: "3%", color: "#000" }}
                                canSearch="true"
                              >
                                {" "}
                                Remote Order
                              </TableCell>
                            )}

                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Unvisited Outlet
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Zero Order
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Total Order Amount
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ width: "3%", color: "#000" }}
                            canSearch="true"
                          >
                            Total Sales Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dashboardData2.salesInfo.length != 0 &&
                          this.getFilteredTableDataForSalesTeamList(
                            value == 0
                              ? dashboardData2?.salesInfo
                              : value == 1
                                ? dashboardData2?.salesInfo.filter(
                                  (row) => row.attendenceStatus == 1
                                )
                                : value == 2
                                  ? dashboardData2?.salesInfo.filter(
                                    (row) => row.attendenceStatus == 0
                                  )
                                  : dashboardData2?.salesInfo.filter(
                                    (row) => row.checkInStatus == 1
                                  )
                          )?.map((salesTeamObject, index) => {
                            return (
                              <TableRow>
                                <TableCell
                                  align="center"
                                  canSearch="true"
                                  width="5%"
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell width="15%" canSearch="true">
                                  <Link
                                    color={cyanBlue}
                                    component={RouterLink}
                                    to={
                                      "/sales/" +
                                      salesTeamObject.salesTeamId +
                                      "/" +
                                      salesTeamObject.userTypeId
                                    }
                                  >
                                    {salesTeamObject.name}
                                  </Link>
                                </TableCell>
                                {localStorage.getItem(
                                  "showAreaDistrictColumnsOnSalesTeamListDashboard"
                                ) &&
                                  localStorage.getItem(
                                    "showAreaDistrictColumnsOnSalesTeamListDashboard"
                                  ) == 1 && (
                                    <>
                                      <TableCell align="left" canSearch="true">
                                        {salesTeamObject.district_names}
                                      </TableCell>

                                      <TableCell align="left" canSearch="true">
                                        {salesTeamObject.area_names}
                                      </TableCell>
                                    </>
                                  )}
                                <TableCell
                                  width="2%"
                                  align="right"
                                  canSearch="true"
                                >
                                  <div
                                    onClick={(e) =>
                                      this.salesTeamHandler(
                                        e,
                                        salesTeamObject.salesTeamId
                                      )
                                    }
                                    style={{
                                      color: cyanBlue,
                                      cursor: "pointer",
                                    }}
                                  >
                                    {salesTeamObject.beatCount}
                                  </div>
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.totalOutletCount}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.productiveCall}
                                </TableCell>
                                {localStorage.getItem("isShowRemoteOrderColumnAtAnalyticalDashboard") &&
                                  localStorage.getItem("isShowRemoteOrderColumnAtAnalyticalDashboard") ==
                                  1 && (
                                    <TableCell align="right" canSearch="true">
                                      {salesTeamObject.remoteOrderCount}
                                    </TableCell>
                                  )}

                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.unvisitedOutletCount}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {salesTeamObject.zeroOrderCount}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {(+salesTeamObject.totalAmount).toFixed(2)}
                                </TableCell>
                                <TableCell align="right" canSearch="true">
                                  {(+salesTeamObject.totalSalesAmt).toFixed(2)}
                                </TableCell>
                              </TableRow>
                            );
                          })}

                        <TableRow>
                          {localStorage.getItem(
                            "showAreaDistrictColumnsOnSalesTeamListDashboard"
                          ) &&
                            localStorage.getItem(
                              "showAreaDistrictColumnsOnSalesTeamListDashboard"
                            ) == 1 ? (
                            <TableCell align="right" width="2%" colSpan={5}>
                              Total
                            </TableCell>
                          ) : (
                            <TableCell align="right" width="2%" colSpan={3}>
                              Total
                            </TableCell>
                          )}

                          <TableCell TableCell align="right">
                            {totalOutletCount}
                          </TableCell>
                          <TableCell align="right">{productiveCall}</TableCell>
                          {localStorage.getItem("isShowRemoteOrderColumnAtAnalyticalDashboard") &&
                            localStorage.getItem("isShowRemoteOrderColumnAtAnalyticalDashboard") == 1 && (
                              <TableCell align="right">{remoteOrder}</TableCell>
                            )}
                          <TableCell align="right">{unvisited}</TableCell>
                          <TableCell align="right">{zero}</TableCell>
                          <TableCell align="right">
                            {totalAmount.toFixed(2)}
                          </TableCell>
                          <TableCell align="right">
                            {salesAmt.toFixed(2)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {beatPopupFlag && (
                    <BeatPopUp
                      open={beatPopupFlag}
                      handleCloses={this.handleClosesSalesTeam}
                      columns={[
                        {
                          title: "Sr. No.",
                          name: "index",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "center",
                          canSearch: true,
                        },
                        {
                          title: "Beat",
                          name: "beatName",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                          canSearch: true,
                        },
                      ]}
                      rows={beatList?.beatFromSalesTeamId}
                    />
                  )}
                </div>
              </div>

              <footer className="footer">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-6">2022 Â© Byte Elephants. </div>
                    <div className="col-sm-6">
                      <div className="text-sm-end d-none d-sm-block">
                        {" "}
                        Designed &amp; Developed by Byte Elephants Technologies
                        PVT LTD{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  stockHolderSummaryList: state.stockHolderDashboard,
  salesDataMonthList: state.stackholder,
  salesDataDateList: state.stackholder,
  dashboardData2: state.adminDashboard,
  beatList: state.beat,
});

const mapDispatchToProps = {
  getStockHolderSummary,
  getSalesDataByMonth,
  getSalesDataByDate,
  getPendingBills,
  getTopPerformingEntities,
  getSalesTeamInfoByDatesWithAttendance,
  getBeatFromSalesTeamId,
  showLoador,
  showNotification,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalyticalStockHolderDashboard);
